import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 3,
        rowsSize: [4, 0.5, 1],
        colSpan: {
          "2:0": 2,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/frequency-chart-1.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/frequency-chart-2.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Filter bank",
                    scrollbars: false,
                    styles: {
                      fontWeight: 700,
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Filtered signal",
                    scrollbars: false,
                    styles: {
                      fontWeight: 700,
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "hint",
                  options: {
                    data:
                      "A set of filterbanks are used to model the frequency to place transform which takes place in the basillar membrane. Figures below show the transfer function of the filter bank and the filtered signal.",
                    direction: "row",
                  },
                },
                styles: {
                  width: "615px",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
